import { Navigate } from 'react-router'

import { Icon } from '@fv/client-components'

import { routes } from '@/routes'

import { useAddresses } from '../addresses/useAddress'
import { useCustomerRoutedDraft } from '../customer-routed/hooks'
import { BookingForm } from './BookingForm'
import { BookingFormProvider } from './BookingFormProvider'

export const CustomerRoutedBookingPage = () => {
  const parsed = useCustomerRoutedDraft()
  const load = parsed?.[0]
  const workflow = load?.workflow ?? 'ltl'
  const addressesQuery = useAddresses(load)

  if (!load || workflow === 'truckload') {
    return <Navigate replace to={routes.quote(workflow)} />
  }

  if (addressesQuery.loading) {
    return (
      <div className="bg-white px-6 py-8 overflow-auto">
        <Icon icon="sync" />
        <span className="ml-2">Loading...</span>
      </div>
    )
  }

  return (
    <BookingFormProvider
      addresses={addressesQuery.data}
      load={load}
      isNew={true}
    >
      <BookingForm />
    </BookingFormProvider>
  )
}
